/**
 * G1 — dismiss-first while Collect/overlays open, then run chrome open / navigate.
 * Coherent with Policy A: do not raise BottomSheet z-index; close top OverlayBackDismiss first.
 *
 * If overlayDismiss returns exactly `false`, skip then() (e.g. Collect continuePending).
 * Publishers may return boolean; stack typing remains `() => void` (return ignored at type level).
 */
export function dismissOverlayThen(
  overlayDismiss: (() => boolean | void) | (() => void) | null | undefined,
  then: () => void,
): void {
  if (overlayDismiss == null) {
    then();
    return;
  }
  const result = overlayDismiss();
  if (result === false) {
    return;
  }
  then();
}
